import { Component, Input, OnInit } from '@angular/core';
import { Employee } from "../../core/models/employee.model";

@Component({
    selector: 'app-address-show',
    templateUrl: './address-show.component.html',
    styleUrls: ['./address-show.component.css']
})
export class AddressShowComponent implements OnInit {

    @Input()
    employee: Employee;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/verification-show/address-show/address-show.component.ts